
  
        <div class="form-group mt-3 row">
            <div style="text-align: right;" class="col-12">
                <b>{{'Address' | translate}} :</b> {{caseInfoAfterVerficationCaseSource.correspondenceSubject}}
            </div>
        </div>
        <div class="form-group mt-3 row">
            <div style="text-align: right;" class="col-4">
                <b>{{'TransactionNumber' | translate}} :</b> {{caseInfoAfterVerficationCaseSource.correspondenceNumber}}
            </div>
            <div style="text-align: right;" class="col-4">
                <b>{{'HijriYear' | translate}} :</b> {{caseInfoAfterVerficationCaseSource.hijricYear}}
            </div>
            <div style="text-align: right;" class="col-4">
                <b>{{'ConfidentialityDegree' | translate}} :</b> {{caseInfoAfterVerficationCaseSource.confidentialityDesc}}
            </div>
        </div>

        <div class="form-group mt-3 row">
            <div style="text-align: right;" class="col-6">
                <b>{{'FromManagement' | translate}} :</b> {{caseInfoAfterVerficationCaseSource.ownerDepartmentDesc}}
            </div>
            <div style="text-align: right;" class="col-6">
                <b>{{'ToManagement' | translate}} :</b> {{caseInfoAfterVerficationCaseSource.receiveByDepartmentDesc}}
            </div>
        </div>
        <div class="form-group mt-3 row">
            <div style="text-align: right;" class="col-12">
                <b>{{'Attachments' | translate}} : </b>
                <a *ngFor="let doc of caseInfoAfterVerficationCaseSource.documentList" (click)="download(doc);" class="btn btn-sm btn-outline-primary me-1">
                    <app-feather-icons [icon]="'download'"></app-feather-icons> <b>{{doc.name}}</b>

                </a>
            </div>

        </div>
        <div class="form-group mt-3 row">

            <div style="text-align: right;" class="col-12">
                <div class="row">
                    <b class="col-2 me-3">{{'Notes' | translate}} :</b>
                    <p class="col-9">{{caseInfoAfterVerficationCaseSource.remarks}} </p>
                </div>
            </div>
        </div>
   
   